<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="personalBackground"
      label-width="80px"
    >
      <formTitle title="子女學業背景 Education Background"></formTitle>
      <div class="row-list">
        <el-row type="flex" align="middle">
          <el-col :xl="12" :xs="24">
            <div class="plain-button-title">
              現時/最後就讀學校資料 Current /Last Attended Year Level
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :xs="24">
            <el-form-item label="學校名稱 School Name">
              <el-input
                :disabled="isView"
                v-model="personalBackground.currentSchoolInformation.schoolName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :xs="24">
            <el-form-item label="學校地址 School Address">
              <el-input
                :disabled="isView"
                v-model="
                  personalBackground.currentSchoolInformation.schoolAddress
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :xs="24">
            <el-form-item
              label="學校電話 School Contact Number "
              :prop="'currentSchoolInformation.schoolContactNumber'"
              :rules="[
                {
                  pattern: /^[0-9]+$/,
                  message: '請輸入純數字',
                  trigger: 'change',
                },
              ]"
            >
              <el-input
                :maxlength="8"
                :disabled="isView"
                v-model="
                  personalBackground.currentSchoolInformation
                    .schoolContactNumber
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :xs="24">
            <el-form-item
              label="學校電郵 School Email"
              :prop="'currentSchoolInformation.schoolEmail'"
              :rules="[
                {
                  pattern:
                    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})+$/,
                  message: '請輸入正確的郵箱地址',
                  trigger: 'change',
                },
              ]"
            >
              <el-input
                :disabled="isView"
                v-model="
                  personalBackground.currentSchoolInformation.schoolEmail
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :xs="24">
            <el-form-item label="入讀日期 First Attendance Date">
              <el-date-picker
                :disabled="isView"
                v-model="personalBackground.currentSchoolInformation.dateJoined"
                format="yyyy-MM-dd"
                type="date"
                placeholder="選擇日期 Select date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :xs="24">
            <el-form-item
              label="現時/最後就讀級別 Current /Last Attended Year Level"
            >
              <el-input
                :disabled="isView"
                v-model="
                  personalBackground.currentSchoolInformation
                    .currentAttendedYearLevel
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :xs="24">
            <el-form-item
              label="申請人是否現就讀該校?	Is the applicant attending this school now? "
            >
              <el-radio-group
                :disabled="isView"
                v-model="
                  personalBackground.currentSchoolInformation
                    .isTheApplicantAttendingTheSchool
                "
              >
                <el-radio :label="true">是 Yes</el-radio>
                <el-radio :label="false">不是 No</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="row-list">
        <el-row :gutter="20"  align="middle">
          <el-col :xl="9" :xs="24">
            <div class="plain-button-title">
              曾就讀學校資料 Previous School Information
            </div>
          </el-col>
          <el-col :xl="3" :xs="24"> (最後就讀學校排先) </el-col>
        </el-row>
        <div
          v-for="(item, index) in personalBackground.previousSchoolInformation"
          :key="index"
        >
          <el-row :gutter="20">
            <el-col :xl="12" :xs="24">
              <el-form-item label="學校名稱 School Name ">
                <el-input
                  :disabled="isView"
                  v-model="item.schoolName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="12" :xs="24">
              <el-form-item label="主要授課語言 Main Medium of Instruction">
                <el-input
                  :disabled="isView"
                  v-model="item.mainMediumOfInstruction"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xl="12" :xs="24">
              <el-form-item label="班級 Grade / Class">
                <el-input :disabled="isView" v-model="item.class"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="12" :xs="24">
              <el-form-item label="日期 Date ">
                <el-row :gutter="20" type="flex">
                  <el-col :span="10">
                    <el-date-picker
                      :disabled="isView"
                      v-model="item.startDate"
                      type="date"
                      placeholder="選擇日期 Select date"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col :span="4" style="text-align: center;">至 To</el-col>
                  <el-col :span="10">
                    <el-date-picker
                      :disabled="isView"
                      v-model="item.endDate"
                      type="date"
                      placeholder="選擇日期 Select date"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-button
          v-if="!isView"
          icon="el-icon-delete"
          class="wordWrap"
          style="margin-bottom: 10px;"
          type="warning"
          @click="onDeleteSchoolInformation(index)"
        >
          删除 Delete</el-button
        >
        </div>
       
        <el-button
          v-if="!isView"
          icon="el-icon-plus"
          class="wordWrap"
          type="warning"
          @click="onAddSchoolInformation"
        >
          增加學校資料 Add School Information</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import formTitle from "@/components/formTitle";
export default {
  components: { formTitle },
  props: {
    personalBackground: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onDeleteSchoolInformation(index){
      this.personalBackground.previousSchoolInformation.splice(index, 1)
    },
   
    onAddSchoolInformation() {
      let newStudent = {
        schoolName: "",
        class: "",
        mainMediumOfInstruction: "",
        startDate: "",
        endDate: "",
      };
      this.personalBackground.previousSchoolInformation.push(newStudent);
    },
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>

<style lang="scss" scoped>
.document-identity-radio {
  display: flex;
  flex-direction: column;
}
.document-identity-radio .el-radio {
  display: flex;
  margin-bottom: 20px;
}
.el-button--primary {
  width: auto;
}
.row-list {
  padding: 30px 0;
  border-bottom: 1px solid #e5e5e5;
}
.from-button-group {
  margin-top: 30px;
}
::v-deep {
  .el-input__inner {
    border-color: #72acff;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  ::v-deep {
    .el-form-item__label {
      line-height: 1.25rem;
    }
  }
}
</style>